var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0D4029"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.81 19.97 19.78 3l1.414 1.414-16.97 16.97z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.223 3 16.97 16.97-1.414 1.415L2.81 4.415z"
}))));
export default SvgMenuClose;